import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "./SideBar";
import "./SidebarPage.css"; // Create this for better scalability
const API_URL = process.env.REACT_APP_API_URL;
const LOGIN_API_URL = process.env.REACT_APP_LOGIN_API_URL;
const SidebarPage = () => {
  const navigate = useNavigate();  
  const [siteManagerCount, setSiteManagerCount] = useState(0);
  const [productManagerCount, setProductManagerCount] = useState(0);
  const [technicianCount, setTechnicianCount] = useState(0);
  const [userCount, setUserCount] = useState(0);
  const [deviceCount, setDeviceCount] = useState(0); // If devices are part of user data or separate
  useEffect(() => {
    if (!localStorage.getItem("loginId")) {
      navigate("/");
    }
    // eslint-disable-next-line
  }, []);
  const cards = [
    ...(localStorage.getItem("role") === "Product Manager" ||
    localStorage.getItem("role") === "Site Manager"
      ? [
          {
            title: "Site Managers",
            count: siteManagerCount,
            label: "Site Managers",
            route: "/alluser",
            icon: require("../img/people2.png"), // Add this
          },
        ]
      : []),

    ...(localStorage.getItem("role") === "Product Manager"
      ? [
          {
            title: "Product Managers",
            count: productManagerCount,
            label: "Product Managers",
            route: "/alluser",
            icon: require("../img/leader1.png"), // Add this
          },
        ]
      : []),
    ...(localStorage.getItem("role") === "Product Manager" ||
    localStorage.getItem("role") === "Site Manager"
      ? [
          {
            title: "Technicians",
            count: technicianCount,
            label: "Technicians",
            route: "/alluser",
            icon: require("../img/technician.png"), // Add this
          },
        ]
      : []),
    ...(localStorage.getItem("role") !== "User"
      ? [
          {
            title: "Users",
            count: userCount,
            label: "Users",
            route: "/alluser",
            icon: require("../img/team.png"), // Add this
          },
        ]
      : []),

    {
      title: "Devices",
      count: deviceCount,
      label: "Devices",
      route: "/mac",
      icon: require("../img/settings1.png"), // Add this
    },
  ];

  const getusers = async () => {
    const role = localStorage.getItem("role");
    const userId = localStorage.getItem("loginId");
    // setCurrentRole(role);

    fetch(`${LOGIN_API_URL}/login.php?getallusers=true`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            `HTTP error! Status: ${response?.status} ${response?.statusText}`
          );
        }
        return response.json();
      })
      .then((result) => {
        //console.log(result, "######### data from api #########");
        if (result.status === "No room added") {
        } else {
          // setAllUsers(result)

          const siteManagers = result.filter(
            (user) => user.role === "Site Manager"
          );
          const productManagers = result.filter(
            (user) => user.role === "Product Manager"
          );
          const technicians = result.filter(
            (user) => user.role === "Technician"
          );
          const users = result.filter((user) => user.role === "User");
          let filtered = result;
          setSiteManagerCount(siteManagers.length);
          setProductManagerCount(productManagers.length);
          setTechnicianCount(technicians.length);
          setUserCount(users.length);
          switch (role) {
            case "Product Manager":
              // Show all
              break;

            case "Site Manager":
              // Hide ProductManagers
              filtered = result.filter(
                (user) => user.role !== "Product Manager"
              );
              break;

            case "Technician":
              // Show only users with role "user"
              filtered = result.filter((user) => user.role === "User");
              break;

            case "User":
              // Show only current user
              // eslint-disable-next-line
              filtered = result.filter((user) => user.loginId === userId);
              break;

            default:
              break;
          }
        }
      })
      .catch((error) => {
        console.log(error, "Error");
      });
  };

  const getmac = async () => {
    const userId = localStorage.getItem("loginId");
    const role = localStorage.getItem("role");
    fetch(`${API_URL}/index.php?getmac=true`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((responseData) => {
      //  console.log(responseData);
        if (role === "User") {
          const users = responseData.filter((user) => user.userid === userId);

          setDeviceCount(users.length);
        } else {
          setDeviceCount(responseData.length);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getusers();
    getmac();
  }, []);

  return (
    <div
      style={{
        display: "flex",
        height: "100vh",
        width: "100%",
        backgroundColor: "#fff",
      }}
    >
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content */}
      <div
        style={{
          flex: 1,
          padding: "40px",
          background: "linear-gradient(to bottom right, #f9f9ff, #eef2f7)",
          overflowY: "auto",
          minHeight: "100vh",
        }}
      >
        <h1
          style={{
            marginBottom: 30,
            fontSize: "32px",
            fontWeight: "600",
            color: "#489ff6",
          }}
        >
          Welcome
        </h1>

        {/* Cards Grid */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: 24,
            justifyContent: "space-between",
          }}
        >
          {cards.map((card, index) => (
            <div
              key={index}
              onClick={() => {
                navigate(card.route, {
                  state: { role: card?.label },
                });
              }}
              style={{
                flex: "1 1 calc(33.333% - 24px)",
                minWidth: "260px",
                height: "220px",
                background: "rgba(255, 255, 255, 0.1)",
                borderRadius: "20px",
                padding: "24px",
                boxShadow:
                  "0 8px 30px rgba(0, 0, 0, 0.05), inset 0 0 0 0.5px rgba(255,255,255,0.1)",
                backdropFilter: "blur(16px)",
                WebkitBackdropFilter: "blur(16px)",
                border: "1px solid rgba(255, 255, 255, 0.2)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                transition: "all 0.35s ease",
                cursor: "pointer",
                textAlign: "center",
                position: "relative",
                overflow: "hidden",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.04)";
                e.currentTarget.style.boxShadow =
                  "0 12px 36px rgba(0, 123, 255, 0.25), inset 0 0 0 0.5px rgba(255,255,255,0.2)";
                e.currentTarget.style.border =
                  "1px solid rgba(0, 123, 255, 0.35)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1)";
                e.currentTarget.style.boxShadow =
                  "0 8px 30px rgba(0, 0, 0, 0.05), inset 0 0 0 0.5px rgba(255,255,255,0.1)";
                e.currentTarget.style.border =
                  "1px solid rgba(255, 255, 255, 0.2)";
              }}
            >
              {/* Icon */}
              {card.icon && (
                <div
                  style={{
                    marginBottom: 16,
                    filter: "drop-shadow(0 4px 8px rgba(0, 123, 255, 0.25))",
                  }}
                >
                  <img
                    src={card.icon}
                    alt={card.title}
                    style={{ width: 52, height: 52, opacity: 0.95 }}
                  />
                </div>
              )}

              {/* Count */}
              <div
                style={{
                  fontSize: 40,
                  fontWeight: "800",
                  background: "linear-gradient(90deg, #007bff, #00c6ff)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  letterSpacing: "1px",
                  marginBottom: 4,
                  fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                  userSelect: "none",
                }}
              >
                {card.count}
              </div>

              {/* Title */}
              <div
                style={{
                  fontSize: 17,
                  color: "#333",
                  fontWeight: "600",
                  letterSpacing: "0.03em",
                  textTransform: "capitalize",
                  userSelect: "none",
                  opacity: 0.85,
                }}
              >
                {card.title}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SidebarPage;
